import { render, staticRenderFns } from "./EventGroups.vue?vue&type=template&id=08e08b29&scoped=true&"
import script from "./EventGroups.vue?vue&type=script&lang=js&"
export * from "./EventGroups.vue?vue&type=script&lang=js&"
import style0 from "./EventGroups.vue?vue&type=style&index=0&id=08e08b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e08b29",
  null
  
)

export default component.exports